import React, { memo } from 'react'
import { ContactCenterModal } from './ContactCenterModal'
import { MODALSTATE } from './contact-center.store'
import { useContactCenterModalState } from './contact-center.hooks'

export interface IContactCenter {}

const ContactCenter: React.FC<IContactCenter> = props => {
  const { modalState } = useContactCenterModalState()

  if (modalState === MODALSTATE.CLOSE) return null

  return <ContactCenterModal />
}

export default memo(ContactCenter)
